import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';

// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { PropTypes } from 'prop-types';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { deleteItem } from '../../fetch';
import { aerosActions } from '../../store';
import { useTranslation } from '../../common/LocalizationProvider';
import AerosDetailsRemove from './AerosDetailsRemove';
import { selectSession } from '../../createSelectorUtils';
// ----------------------------------------------------------------------

AerosDetailsMoreMenu.propTypes = {
  id: PropTypes.number
};

export default function AerosDetailsMoreMenu({ id }) {
  const t = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const session = useSelector(selectSession);

  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);

  const handleDelete = async () => {
    const response = await deleteItem(`aeros/runway`, id);

    if (response.ok) {
      enqueueSnackbar(t('Aero_Snackbar_Delete'), { variant: 'success' });
      dispatch(aerosActions.deleteRunways(id));
      setOpenRemove(false);
      setIsOpen(false);
    } else {
      response.text().then((error) => {
        const message = error.slice(0, error.indexOf('-'));
        enqueueSnackbar(message, { variant: 'error' });
      });
      setOpenRemove(false);
    }
  };
  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem
          onClick={() => navigate('../edit/runways', { state: { id } })}
          sx={{ color: 'text.secondary' }}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary={t('btn_Edit')} primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        {session.administrator && (
          <MenuItem sx={{ color: 'text.secondary' }} onClick={() => setOpenRemove(true)}>
            <ListItemIcon>
              <Icon icon={trash2Outline} width={24} height={24} />
            </ListItemIcon>
            <ListItemText primary={t('btn_Delete')} primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Menu>
      <AerosDetailsRemove
        open={openRemove}
        handleClose={() => setOpenRemove(false)}
        handleDelete={handleDelete}
      />
    </>
  );
}
